import { useEffect, useState } from 'react';

declare const __CLIENT__: boolean;

export const getWindowDimensions = () => {
	if (!__CLIENT__) return { width: 0, height: 0 };
	const { innerWidth: width, innerHeight: height } = window;
	return {
		width,
		height
	};
};

const useWindowDimensions = () => {
	const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

	useEffect(() => {
		const handleResize = () => {
			setWindowDimensions(getWindowDimensions());
		};

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return windowDimensions;
};
export default useWindowDimensions;
